<!--
 * @Descripttion: 
 * @Author: chenxt
 * @Date: 2025-05-23 12:12:57
-->
<template>
    <div id="previewPDF">
        <!--<van-popup v-model="params.showPdf" close-on-click-overlay="false" closeable="true" overlay="false">-->
        <div class="pdf-panel">
            <iframe :src="pdfSrc" class="iframe-panel" width="100%" height="100%">
            </iframe>
        </div>
        <!--</van-popup>-->
    </div>
</template>

<script>
import { loading } from '@/common/loading'
import config from '@/config/index'
import axios from "axios";
import { Toast } from "vant";
    export default {
        name: "previewPDF",
        data() {
            return {
              pdfSrc: ''
            }
        },
        created() {
        },
        mounted() {
          this.init()
        },
        methods: {
          init() {
            let newTime = new Date().getTime() ; // 获取现在的时间戳
            if(this.isOneDayApart(newTime, Number(this.$route.query.timestamp))) {
              return Toast.fail("文件已失效!")
            }
            loading(true)
            axios({
              url: config.devProxy +
              `/ythyw/monitorReportUrls/downloadPdfFileGet?reportId=${this.$route.query.id}`, //接口地址
              method: "get",
              responseType: "blob",
            }).then((res) => {
              const blob = new Blob([res.data])
              this.pdfSrc = '/pdfjs/web/viewer.html?file=' + window.URL.createObjectURL(blob)
              loading(false)
            }).catch((res)=> {
              loading(false)
              Toast.fail("文件出错!")
              return
            })
          },
          isOneDayApart(timestamp1, timestamp2) {
            const diffInMs = Math.abs(timestamp2 - timestamp1); // 计算时间差（取绝对值）
            const diffInHours = diffInMs / (1000 * 60 * 60); // 将毫秒转换为小时
            const flag = diffInHours >= 24
            return flag; // 检查是否大于或等于24小时
          }
        },

    }
</script>

<style lang="scss" scoped>
    #previewPDF {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1000;
        .pdf-panel {
            height: 100%;
            .pdf-title {
                background: #4494f3;
                color: #fff;
                height: px2rem(115);
                font-size: px2rem(44);
                font-family: Arial;
                padding-right: 0.24rem;
                a {
                    float: right;
                    height:  px2rem(44);
                    line-height:  px2rem(115);
                }
            }
        }
    }
</style>